import React from 'react';
import classNames from 'classnames';
import LikeIcon from 'icons/Like.icon';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';

import './NudgeInterested.styles.scss';
import './NudgeInterested.styles.responsive.scss';

type NudgeInterestedProps = {
  className?: string;
  areActionsDisabled?: boolean;
  isSubmitting?: boolean;
  text: string;
  confirmCtaText?: string;
  notForMe: () => void;
  registerInterest: () => void;
};

const NudgeInterested: React.FC<NudgeInterestedProps> = (props) => {
  const {
    className,
    text,
    confirmCtaText,
    areActionsDisabled = false,
    isSubmitting = false,
    notForMe,
    registerInterest,
  } = props;

  const classes = classNames('nudge-interested', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>{text}</p>

      <Button
        className="confirm"
        disabled={isSubmitting}
        {...(!areActionsDisabled && { onClick: registerInterest })}
      >
        <LikeIcon />
        {confirmCtaText || t('registerInterest')}
      </Button>

      <Button
        className="decline"
        variant="outline"
        disabled={isSubmitting}
        {...(!areActionsDisabled && { onClick: notForMe })}
      >
        <LikeIcon />
        {t('notForMe')}
      </Button>
    </div>
  );
};

export default NudgeInterested;
